import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import PrivateRoute from '~src/components/organisms/PrivateRoute';
import { PageViewProvider } from '~src/components/providers/pageview-provider';
import NotFound from '~src/pages/NotFound';
import { usePageView } from '@usermaven/react';
import { PRIVATE_ROUTES } from './private';
import { PUBLIC_ROUTES } from './public';

const TaxarooRoutes: FC = () => {
  usePageView();

  return (
    <Routes>
      {PUBLIC_ROUTES.map((route) => (
        <Route key={route.path} {...route} />
      ))}
      {PRIVATE_ROUTES.map(({ element, ...route }) => (
        <Route key={route.path} element={<PrivateRoute>{element}</PrivateRoute>} {...route} />
      ))}
      <Route
        path="*"
        element={(
          <PageViewProvider>
            <NotFound />
          </PageViewProvider>
        )}
      />
    </Routes>
  );
};

export default TaxarooRoutes;
